import Vue from "vue";
import Vuex from "vuex";

import alert from "@/store/alert.module";
import param from "@/store/param.module";
import client from "@/store/client.module";
import triplist from "@/store/triplist.module";
import auth from "@/store/auth.module";
import container from "@/store/container.module";
import participant from "@/store/participant.module";
import billing from "@/store/billing.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    alert,
    param,
    client,
    triplist,
    auth,
    container,
    participant,
    billing,
  },
  state: {},
  mutations: {},
  actions: {},
});
